/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useContext } from "react";
import { ShopContext } from "../Context/ShopContext";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import images from "../../assets/images/assets";
import { toast } from "react-toastify";

function PaystackVerify() {
  const { setCartItems, backendUrl, token } = useContext(ShopContext);
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId");
  const [verificationStatus, setVerificationStatus] = useState("loading"); // loading, success, error

  console.log(verificationStatus);

  useEffect(() => {
    const verifyPayment = async () => {
      try {
        console.log(token);
        const response = await axios.get(
          `${backendUrl}/api/order/verify-paystack?orderId=${orderId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Added "Bearer " prefix
            },
          }
        );

        console.log(response.data.object);

        if (response.data.success) {
          setCartItems({});
          setVerificationStatus("success");
          toast.success(response.data.message);
        } else {
          setVerificationStatus("error");
          toast.error(response.data.message);
        }

        // console.log(response.data);
      } catch (error) {
        console.log("Payment verification failed:", error);
        setVerificationStatus("error");
      }
    };

    verifyPayment();
  }, [orderId, setCartItems, token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md text-center">
        <img
          src={images.paystack_logo}
          alt="paystack logo"
          className="w-28 lg:w-32 mx-auto mb-6 animate-pulse" // Added pulse animation
        />

        {verificationStatus === "loading" && (
          <div className="space-y-4">
            <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-indigo-500  mx-auto"></div>
            <p className="text-gray-600">Verifying payment...</p>
          </div>
        )}

        {verificationStatus === "success" && (
          <div className="space-y-4">
            <img
              src={images.success_icon} // Replace with your success icon
              alt="success icon"
              className="w-20 mx-auto animate-bounce" // Added bounce animation
            />
            <h2 className="text-2xl font-bold text-green-600">
              Payment Verified!
            </h2>
            <p className="text-gray-600">
              Your payment was successful. Your cart has been cleared.
            </p>
          </div>
        )}

        {verificationStatus === "error" && (
          <div className="space-y-4">
            <img
              src={images.error_icon} // Replace with your error icon
              alt="error icon"
              className="w-20 mx-auto animate-shake" // Added shake animation
            />
            <h2 className="text-2xl font-bold text-red-600">
              Payment Failed !
            </h2>
            <p className="text-gray-600">
              There was an error verifying your payment. Please try again or
              contact support.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default PaystackVerify;
